import { useEffect } from 'react';

const useDebouncedEffect = (callback, dependencies, debounceBy = 500) => {
  useEffect(() => {
    const timeoutId = setTimeout(callback, debounceBy);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [...dependencies, callback, debounceBy]);
};

export default useDebouncedEffect;
